import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: 24,

    '&.small': {
      fontSize: 18,
    },

    '&.big': {
      fontSize: 36,
    },

    '& .rating': {
      '&-list': {
        '&-container': {
          display: 'flex',
        },
        '&-item': {
          cursor: 'pointer',
          '&.filled': {
            color: '#FFDC60',
          },
          '&.empty': {
            color: theme.palette.custom.surface[3],

            '&:hover, &.hovered': {
              color: theme.palette.custom.surface[4],
            },
          },
        },
      },
      '&-legend': {
        color: theme.palette.text.hint,
        margin: theme.spacing(1, 0, 0, 0),
      },
    },
  },
}));

export default styles;
